<mat-card>
  <mat-toolbar style="float: left;clear: both;width: 100%;" color="secondary">
    <h3 mat-line style="font-weight: normal;color: black">{{ 'usuaris.titol' | translate }}</h3>
    <button *ngIf="userInfo.admin"
      style="margin-left: auto;margin-right: 0" mat-icon-button
      (click)="addNewUser()">
      <mat-icon color="primary" style="font-size: 24px">person_add</mat-icon>
    </button>
  </mat-toolbar>
  <mat-progress-bar mode="indeterminate" color="warm" *ngIf="showAsyncProgress" style="position: absolute;"></mat-progress-bar>
  <mat-card-content style="padding: 24px;margin: auto;width: 90%">
    <table>
      <thead> 
        <tr>
          <th>{{ 'usuaris.colNom' | translate }}</th>
          <th>{{ 'usuaris.colCarrec' | translate }}</th>
          <th>{{ 'usuaris.colFormacions' | translate }}</th>
          <th>{{ 'usuaris.colCorreu' | translate }}</th>
          <th>{{ 'usuaris.colTelefon' | translate }}</th>
          <th>{{ 'usuaris.colInici' | translate }}</th>          
          <th style="width: 210px;text-align: center">{{ 'usuaris.colAccions' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of userList">
          <td>
            {{user.name}}
          </td>
          <td>
            {{user.carrec}}
          </td>
          <td>
            {{user.formacio}}
          </td>
          <td>
            {{user.email}}
          </td> 
          <td>
            {{user.telefon}}
          </td>  
          <td>
            {{user.data_inici}}
          </td>                           
          <td>
            <mat-button-toggle-group multiple *ngIf="userInfo.admin && false">
              <mat-button-toggle [checked]="user.active" (click)="changeActivity('active', user, !user.active)">{{ 'usuaris.actiu' | translate }}</mat-button-toggle>&nbsp;&nbsp;
              <mat-button-toggle [checked]="user.admin" (click)="changeActivity('admin', user, !user.admin)">Admin</mat-button-toggle>
            </mat-button-toggle-group>
            <span *ngIf="!userInfo.admin">{{(user.active ? ('usuaris.actiu' | translate) : ('usuaris.inactiu' | translate))}}</span>
            <button mat-icon-button matTooltip="{{ 'usuaris.editarToolTip' | translate }}" attr.aria-label="{{ 'usuaris.editarToolTip' | translate }}" matTooltipClass="tooltip-style" color="primary"
              *ngIf="userInfo.admin || userInfo.email === user.email"
              (click)="editUser(user)"
              style="width:30px">
              <mat-icon color="primary" style="font-size:24px">mode_edit</mat-icon>
            </button>
            <button mat-icon-button matTooltip="{{ 'usuaris.esborrarToolTip' | translate }}" attr.aria-label="{{ 'usuaris.esborrarToolTip' | translate }}" matTooltipClass="tooltip-style" color="primary"
              *ngIf="userInfo.admin"
              (click)="deleteUser(user)" style="width:30px">
              <mat-icon color="primary" style="font-size:24px">delete_forever</mat-icon>
            </button>
            <button mat-icon-button matTooltip="{{ 'notesPage.modificarCurriculum' | translate }}" attr.aria-label="{{ 'notesPage.modificarCurriculum' | translate }}" matTooltipClass="tooltip-style" color="primary" *ngIf="userInfo.admin || userInfo.email === user.email || canReport()"
              (click)="curriculum(user)" style="width:30px">
              <mat-icon color="primary" style="font-size:24px">person_pin</mat-icon>
            </button>
            <button mat-icon-button matTooltip="{{ 'notesPage.mostrarCurriculumToolTip' | translate }}" attr.aria-label="{{ 'notesPage.mostrarCurriculumAriaLabel' | translate }}" matTooltipClass="tooltip-style" color="primary" style="width:30px" (click)="curriculumV(user.id)">
               <!--<a href="https://datastudio.google.com/s/uMC1oQ7-FNI?filter=personal_curriculum/id_personal eq '{{user.id}}'" target="_blank"> -->
              <mat-icon color="primary" style="font-size:24px">visibility</mat-icon>
            <!--</a> -->
            </button>
            <button mat-icon-button matTooltip="{{ 'notesPage.editarCalendari' | translate }}" attr.aria-label="{{ 'notesPage.editarCalendari' | translate }}" matTooltipClass="tooltip-style"  color="primary" *ngIf="userInfo.admin || userInfo.email === user.email || canReport()"
              (click)="calendari(user)" style="width:30px">
              <mat-icon color="primary" style="font-size:24px">nature</mat-icon>
            </button>
            <button mat-icon-button matTooltip="{{ 'usuaris.anarTreballsToolTip' | translate }}" attr.aria-label="{{ 'usuaris.anarTreballsToolTip' | translate }}" matTooltipClass="tooltip-style" color="primary"
              (click)="treballs(user.id)" style="width:30px">
              <mat-icon color="primary" style="font-size:24px">folder</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </mat-card-content>
</mat-card>

<dialog *ngIf="showDialog" open>
 <mat-card-content>
  <form (submit)="addOrUpdateUser($event)">
    <h3>{{ 'usuaris.dialeg.titolAutenticacio' | translate }}</h3>
    <div>
     <mat-form-field>
      <input matInput style="width: 100%" [disabled]="editUserData.ID !== 'NEW'"
        placeholder="{{ 'usuaris.dialeg.email' | translate }}" name="email" type="email" required
        [(ngModel)]="editUserData.email" ngDefaultControl
      />
     </mat-form-field> 
     <mat-form-field> 
      <input matInput style="width: 100%"
        placeholder="{{ 'usuaris.colNom' | translate }}" name="name" required
        [(ngModel)]="editUserData.name" ngDefaultControl
      />
     </mat-form-field> 
    </div>
    <div>
      <mat-form-field>
       <input matInput 
        placeholder="{{ 'usuaris.dialeg.clau' | translate }}" name="password" (change)="validateEqualPassword($event)" type="password"
        [(ngModel)]="editUserData.password" ngDefaultControl
        #password1
       />
      </mat-form-field> 
      <mat-form-field>
       <input matInput 
        placeholder="{{ 'usuaris.dialeg.repeteixClau' | translate }}" name="repeatPassword" (change)="validateEqualPassword($event)" type="password"
        [(ngModel)]="editUserData.repeatPassword" ngDefaultControl
        #password2
       />
      </mat-form-field> 
    </div>
    <h3>{{ 'usuaris.dialeg.titolPersonals' | translate }}</h3>
    <div>
      <div>
       <mat-form-field>
        <input matInput [disabled]="editUserData.ID !== 'NEW'"
          placeholder="{{ 'usuaris.dialeg.personaId' | translate }}" required name="PERSONA" style="min-width: 45%;"
          [(ngModel)]="editUserData.id" ngDefaultControl
        />
       </mat-form-field> 
       <mat-form-field> 
        <input matInput 
          placeholder="{{ 'usuaris.colTelefon' | translate }}" type="phone" name="phone" style="min-width: 45%;"
          [(ngModel)]="editUserData.telefon" ngDefaultControl
        />
       </mat-form-field> 
      </div>
      <div>
       <mat-form-field> 
        <input matInput 
          placeholder="{{ 'usuaris.dialeg.experiencia' | translate }}" name="anys_experiencia"
          [(ngModel)]="editUserData.anys_experiencia" ngDefaultControl
        />
       </mat-form-field> 
       <mat-form-field> 
        <input matInput 
          placeholder="{{ 'usuaris.dialeg.dataInici' | translate }}" name="data_inici" type="date"
          [(ngModel)]="editUserData.data_inici" ngDefaultControl
        />
       </mat-form-field> 
       <mat-form-field> 
        <input matInput 
          placeholder="{{ 'usuaris.dialeg.dataFi' | translate }}" name="data_fi" type="date"
          [(ngModel)]="editUserData.data_fi" ngDefaultControl
        />
       </mat-form-field>
      </div>
      <div>
       <mat-form-field style="width: 100%">
        <input matInput  style="width: 100%"
          placeholder="{{ 'usuaris.dialeg.formacio' | translate }}" name="formacio" [(ngModel)]="editUserData.formacio" ngDefaultControl
        />
      </mat-form-field> 
      </div>
      <div>
       <mat-form-field>
        <input matInput  style="width: 100%;"
          placeholder="{{ 'usuaris.colCarrec' | translate }}" name="carrec"
          [(ngModel)]="editUserData.carrec" ngDefaultControl
        />
       </mat-form-field> 
      </div>      
    </div>
    <div style="padding-top: 2em; text-align: right;">
      <button mat-button type="submit" style="margin-left: auto; margin-right: 1em;">
        {{ 'usuaris.dialeg.desar' | translate }}
      </button>
      <button mat-button (click)="showDialog = !showDialog">
        {{ 'usuaris.dialeg.tancar' | translate }}
      </button>
   </div>
  </form>
  </mat-card-content>
</dialog>
